import React, { useEffect } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Feature-Flag Onboarding Toast — Fires once per fresh signup after the FIRST
 * dashboard load. Reads `/api/industry-features`, tells the user which modules
 * are hidden for their industry, and offers a link to Settings → Company to
 * change it. Persists dismissal in localStorage so it never fires again.
 */
export default function FeatureFlagOnboardingToast() {
  const KEY = "feature_flag_onboarding_v1";
  useEffect(() => {
    if (localStorage.getItem(KEY) === "1") return;
    (async () => {
      try {
        const r = await api.get("/industry-features");
        const hidden = r.data?.hidden_modules || [];
        const label  = r.data?.industry_label || r.data?.industry_type;
        // Skip toast if nothing is being hidden — nothing interesting to say.
        if (!hidden.length) { localStorage.setItem(KEY, "1"); return; }
        setTimeout(() => {
          toast(`Your workspace is tuned for ${label}`, {
            description: `${hidden.length} module${hidden.length > 1 ? "s" : ""} hidden (${hidden.join(", ")}). Change any time in Settings → Company.`,
            duration: 10000, "data-testid": "feature-flag-toast",
            action: { label: "Settings", onClick: () => window.location.assign("/app/settings?tab=company") },
          });
          localStorage.setItem(KEY, "1");
        }, 800);
      } catch { /* silent */ }
    })();
  }, []);
  return null;
}
